<template>
    <div class="c-app flex-row align-items-center">
        <CContainer>
            <CRow class="justify-content-center">
                <CCol md="8">
                    <CCardGroup>
                        <CCard class="p-4">
                            <CCardBody>
                                <CForm @keyup.enter="validator();sign_in()">
                                    <h2>ورود به پنل کاربری</h2>
                                    <p class="text-muted"></p>
                                    <CInput v-model="form.username.val" :description="form.username.inv" label="شماره موبایل" dir="ltr" />
                                    <CInput v-model="form.password.val" :description="form.password.inv" label="رمز عبور" type="password" dir="ltr" />
                                    <CRow>
                                        <CCol col="6" class="text-left">
                                            <CButton @click="validator();sign_in()" color="primary" class="px-4">ورود</CButton>
                                        </CCol>
                                        <CCol col="6" class="text-right">
                                            <CButton @click="redirect_to('/password/reset')" color="link" class="px-0">تنظیم مجدد رمز عبور</CButton>
                                            <CButton @click="clear_localstorage" color="link" class="px-0">حذف کوکی‌ها</CButton>
                                            <CButton @click="redirect_to('/signup')" color="link" class="d-lg-none">ثبت نام</CButton>
                                        </CCol>
                                    </CRow>
                                </CForm>
                            </CCardBody>
                        </CCard>
                        <CCard color="primary" text-color="white" class="text-center py-5 d-md-down-none" body-wrapper>
                            <CCardBody>
                                <h2>ایجاد حساب کاربری</h2>
                                <p>برای استفاده از خدمات ما با کلیک بر روی دکمه ثبت نام یک حساب کاربری برای خود ایجاد کنید.</p>
                                <CButton @click="redirect_to('/signup')" color="light" variant="outline" size="lg">
                                    ثبت نام
                                </CButton>
                            </CCardBody>
                        </CCard>
                    </CCardGroup>
                </CCol>
            </CRow>
        </CContainer>
    </div>
</template>

<script>
import validator from '../mixins'
export default {
    mixins: { validator },
    data() {
        return {
            form: {
                username: {val: '', inv: '', v: {req: true, max: 64, spec: 'mobile'}},
                password: {val: '', inv: '', v: {req: true, max: 64}}
            },
            disable: false,
        }
    },
    methods: {
        sign_in() {
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form) {
                    data.set(key, this.form[key].val);
                }
                this.axios.post('signin', data)
                    .then(res => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: `${res.data.user_info.first_name} ${res.data.user_info.last_name} خوش آمدید.`
                        });
                        if(this.$store.state.socket != 0){
                            try{
                                this.$store.commit('socket_close');
                            } catch(err){}
                        }
                        localStorage.clear();
                        this.$store.commit('reset');
                        let d = new Date();
                        d.setMinutes(d.getMinutes() + 120);
                        this.$store.commit('set_expires', d);
                        this.$store.commit('set_token', `Bearer ${res.data.token}`);
                        this.$store.commit('set_user_id', res.data.user_info.id);
                        this.$store.commit('set_u_id', res.data.user_info.id);
                        this.$store.commit('set_user_name', `${res.data.user_info.first_name} ${res.data.user_info.last_name}`);
                        this.$store.commit('set_perms', res.data.user_info.user_perm_array);
                        this.$store.commit('set_verif', res.data.user_info.is_verified);
                        if(this.$store.state.verif == true){
                            if (this.$route.query.redirect == undefined) {
                                this.$router.push('/dashboard');
                            } else {
                                this.$router.push(this.$route.query.redirect);
                            }
                        } else {
                            this.$router.push(`/user/${res.data.user_info.id}/edit`);
                        }
                    })
                    .catch(err => {
                        if (err.response.status == 401) {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                text: 'نام کاربری یا رمز عبور اشتباه است.'
                            });
                        } else {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                text: 'خطا! لطفا مجددا تلاش کنید.'
                            });
                        }
                    });
            }
        },
        clear_localstorage(){
            localStorage.clear();
            this.$notify({
                group: 'foo',
                type: 'success',
                text: 'کوکی‌ها با موفقیت حذف شدند.'
            });
        },
        redirect_to(route) {
            this.$router.push(route);
        },
    }
}
</script>
